export default class BaseSimpleContentSwitcher {
    /**
     * @var {string}
     */
    currentPanel = '';

    /**
     * @var {NodeList}
     */
    allPanelTargets = [];

    /**
     * @var {HTMLElement}
     */
    parentContainer = null;

    init() {
        this.parentContainer = this.getParentContainer();

        if(this.parentContainer === null) {
            return;
        }

        this.getPanelTargets();

        this.currentPanel = this.allPanelTargets[0];

        this.showPanel(this.currentPanel);
    }

    /**
     * getParentContainer
     * @returns {HTMLElement}
     */
    getParentContainer() {
        // First check that we have a parent container block
        let containerElement = this.$root.closest('.Pegasus__Container');

        // If we don't have a parent container block, check for a columns block
        if(typeof containerElement === 'undefined' || containerElement === null) {
            containerElement = this.$root.closest('.wp-block-columns');
        }

        // If we don't have a parent container block or a parent columns block then return null
        if(typeof containerElement === 'undefined' || containerElement === null) {
            return null;
        }

        return containerElement;
    }

    /**
     * getPanelTargets
     * @returns {void}
     */
    getPanelTargets() {
        const listItems = this.$root.querySelectorAll('li');

        listItems.forEach((listItem) => {
            const panelTarget = listItem.getAttribute('data-panel-target');

            if(panelTarget !== null) {
                this.allPanelTargets.push(panelTarget);
            }
        });
    }

    /**
     * showPanel
     * @param {string} target 
     */
    showPanel(target) {
        this.allPanelTargets.forEach((panel) => {
            const panelElements = this.parentContainer.querySelectorAll(`#${panel}`);

            if(panelElements !== null) {
                panelElements.forEach((panelElement) => {
                    if(panel === target) {
                        panelElement.classList.remove('hidden');
                        setTimeout(() => {
                            panelElement.classList.remove('opacity-0');
                        },10);
                    } else {
                        panelElement.classList.add('hidden', 'opacity-0', 'transition-opacity', 'duration-500');
                    }
                });
            }
        });
    }

    /**
     * switchPanel
     * @param {string} event 
     */
    switchPanel(event) {
        const target = this.parentContainer.querySelector(`#${event}`);

        if(target === null) {
            return;
        }

        this.currentPanel = event;

        this.showPanel(event);
    }

}

document.addEventListener('alpine:init', () => {
    Alpine.data('simpleContentSwitcher', () => new BaseSimpleContentSwitcher());
});
